class AccountState {

    static get modelName() {
        return 'AccountState';
    }

    constructor(object){
        Object.assign(this, object)
    }

}

export default AccountState;